import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GTProvider } from "gt-react";
import { App } from "./App";
import { LocaleInitializer } from "./i18n";
import "./app.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GTProvider>
      <LocaleInitializer />
      <App />
    </GTProvider>
  </StrictMode>,
);
